import { FC, useContext } from 'react'
import SvgIcon from '../icons/Icon'
import './HeaderLogo.scss'
import { AppContext } from '../../AppContext'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

export const HeaderLogo: FC = () => {
  const { setAudioBuffer } = useContext(AppContext)

  return (
    <a
      className="HeaderLogo"
      href="/"
      onClick={(event) => {
        logger.log(LogActionType.LogoClick)

        event.preventDefault()
        setAudioBuffer(null)
      }}
    >
      <SvgIcon className="icon" />
      <span className="name">Audio Cutter</span>
    </a>
  )
}
